module.exports = __webpack_public_path__ + "img/astana1.bbe96a48.jpg";